module.exports = __webpack_public_path__ + "img/tk.25abceb8.svg";